import { AnonUserCriteria } from 'modules/graphql/types/GraphQLAnonymousCriteria';
import { LastModifiedCell as LastModifiedCellCmp } from 'ui/indexPages/tables/cells';
import { LastModifiedCellWrapper } from '../AnonymousUserTracking.styled';

export const LastModifiedCell = ({ criteria }: { criteria: AnonUserCriteria }) => {
  return (
    <LastModifiedCellWrapper>
      <LastModifiedCellCmp
        createdBy={{ ...criteria.creatorUser, emailAddress: '' }}
        modifiedBy={{ ...criteria.updatedByUser, emailAddress: '' }}
        createdAt={criteria.createdAt}
        modifiedAt={criteria.updatedAt}
      />
    </LastModifiedCellWrapper>
  );
};
